<template>
  <div>
    <ol
      v-if="computedPrograms.length > 0"
      class="mini-programs-element"
    >
      <li
        v-for="program in computedPrograms"
        :key="program.ID"
        class="program-wrapper program--running"
        :title="'Program ' + program.ID + ' is running\n\nClick to go to program'"
        @click="programClicked(program)"
      >
        <div class="mini-programs-element__program">
          <strong>{{ program.ID }} &#8226; {{ program.name }}</strong>

          <div class="mini-programs-element__program__body">
            <div class="mini-programs-element__program__body__days">
              <div
                v-for="(day, index) in program.fullDaySchedule.slice(0, 7)"
                ref="day"
                :key="index"
                class="mini-programs-element__program__body__day"
              >
                <span
                  class="mini-programs-element__program__body__day__name"
                  v-html="(!day.today) ? day.name : 'Today'"
                />
                <div
                  class="mini-programs-element__program__body__day__circle"
                  :class="{'active': (day !== '-')}"
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
export default
{
  name: 'MiniProgramComponent',
  props: {
    programs: {
      type: Array,
      default: function() {
        return[]
      }
    },
    showOnlyRunningPrograms: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedPrograms() {
      return this.programs
    }
  },
  methods: {
    programClicked(program) {
      this.$emit('programClicked', program)
    },
  }
}
</script>

<style lang="scss">
.mini-programs-element {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(244px, 1fr));
  grid-gap: 10px;
  padding-bottom: 10px;

  .program-wrapper {
    padding: 0px;
    box-shadow: none;
  }
  &__program {
    @include program-status-background-color();
    box-sizing: border-box;
    padding: 10px;
    border-radius: $application-base-border-radius;
    text-align: center;

    strong {
      margin: 0 10px 10px;
      text-transform: uppercase;
    }

    >* {
      &:last-child {
        margin-top: 5px;
      }
    }
    $spacing: 10px;

    &__body {
      @include clearfix();
      padding: $spacing $spacing 0;
      background-color: inherit;

      &, &__days-wrapper {
        display: flex;
        align-items: stretch;
        height: 100%;

        > * {
          flex: 0 1 auto;
        }
      }

      &__days-wrapper {
        width: 100%;
      }

      &-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
      }

      &__information {
        margin: 10px 5px 10px 8px;
        font-size: 11px;

        &__station-icon {
          display: inline-block;
          width: 15px;
        }
      }

      &__intelligence-wrapper {
        position: relative;
        left: 6px;
      }
      &__intelligence-levels {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // opacity: 0.2;

        > * {
          flex: 0 1 auto;
        }
      }
      &__intelligence-level {
        @include program-status-background-color();
        flex: 0 1 auto;
        box-sizing: border-box;
        width: 20px;
        height: 100%;
        margin-bottom: 2px;
        background-position: 12px center;
        background-repeat: no-repeat;
        background-size: 40px;

        &:first-child {
          border-top-left-radius: $application-base-border-radius;
        }
        &:last-child {
          border-bottom-left-radius: $application-base-border-radius;
          margin-bottom: 0;
        }
      }

      &__days {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        border: 1px solid $color-grey-dark;
        overflow: hidden;
        border-radius: $application-base-border-radius;
        z-index: $z-normal;
        @include program-status-background-color();
        @include g-program-status-border-color();
      }
      &__day {
        display: inline-block;
        box-sizing: border-box;
        margin: 4px;
        text-align: center;
        font-family: $font-primary-semibold;
        color: $color-grey-dark;

        &__circle {
          // hack to make proportional circle
          height: 18px;
          width: 18px;
          // hack end
          background: $color-white;
          border-radius: 50%;
          border: 1px solid $color-program-active--strong;
          @include program-status-background-color();
          @include g-program-status-border-color();
        }
      }
    }
  }
}
</style>
